import React from 'react'
import "./fact.css"

type FactType = |"rotation" | "revolution" | "radius" | "temperature"; 

const Fact = ({headline, value}:{headline:FactType, value:string}) => {
  
  return (
    <section id='fact'>
      <h6>{headline}</h6>
      <p>{value}</p>
    </section>
  )
}

export default Fact
